import script from "./Register.vue?vue&type=script&lang=ts&setup=true"
export * from "./Register.vue?vue&type=script&lang=ts&setup=true"

import "./Register.vue?vue&type=style&index=0&id=50de5b96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50de5b96"]])

export default __exports__